import React, { Component } from 'react';
import './App.css';
import { Link } from 'react-router-dom'
import $ from 'jquery'
import lokalniIMG from './img/lokalni.jpg';
import outsourcingIMG from './img/outsourcing.jpg';
import prodejSW from './img/prodejhw.jpg';
import Slider from './slick/slider';



class MainHome extends Component {
    componentDidMount(){

        function resetMenu(){
            $("#home a").removeClass("active");
            $("#sluzby-a-produkty-link a").removeClass("active");
            $("#prodej-instalace-li a").removeClass("active");
            $("#lokalni-li a").removeClass("active");
            $("#outsourcing-li a").removeClass("active");
            $("#audit-is-li a").removeClass("active");
            $("#webhosting-li a").removeClass("active");
            $("#webdesign-li a").removeClass("active");
            $("#cenik-praci-li a").removeClass("active");

            $("#o-firme-li a").removeClass("active");
            $("#reference-li a").removeClass("active");
            $("#kontakty-li a").removeClass("active");
            $("#podpora-li a").removeClass("active");
        }

        resetMenu();

        $("#home a").addClass("active");




    }

  render() {

      const settings = {
          dots: true,
          autoplay: true,
          speed: 500,
          autoplaySpeed : 6000
      };

    return (

              <div className="container content fade-in two" id="home">

                  <div className="slider-hp">

                      <Slider {...settings}>
                          <div id="prodej-slide-1" className="slide-hp">
                              <h1>Prodej, instalace a servis HW a SW</h1>
                              <div className="col-sm-5 slider-image"><img alt="" src={prodejSW}/></div>
                              <div className="col-sm-7 slider-description">
                                  <h2>Prodej, servis a instalace počítačů, notebooků a tiskáren.</h2>
                                  <h2>Konfigurace systémů, instalace nových produktů, upgrady, patche apod.</h2>
                                  <h2>Administrace sítí - kompletní instalace a správa serverů</h2>
                                  <h2>Nastavení a zprovoznění LAN sítí</h2>
                                  <div className="col-sm-12 button-wrap">
                                      <Link to="/sluzby-a-produkty/prodej-instalace-servis-hw-sw"><button className="button-slider">Více informací</button></Link>
                                  </div>
                              </div>

                          </div>

                          <div  id="lokalni-slide-2"  className="slide-hp">
                              <h1>Lokální a vzdálená správa sítí</h1>
                              <div className="col-sm-5 slider-image"><img alt="" src={lokalniIMG}/></div>
                              <div className="col-sm-7 slider-description">
                                  <h2>Konfigurace systémů</h2>
                                  <h2>Instalace nových produktů</h2>
                                  <h2>Upgrady, patche, antivirová a antispamová ochrana</h2>
                                  <h2>Preventivní údržba, výkonostní ladění</h2>
                                  <h2>Záloha dat</h2>
                                  <div className="col-sm-12 button-wrap">
                                      <Link to="/sluzby-a-produkty/lokalni-a-vzdalena-sprava-siti"><button className="button-slider">Více informací</button></Link>
                                  </div>
                              </div>
                          </div>

                          <div  id="outsourcing-slide-3"  className="slide-hp">
                              <h1 id="outsourcing-slide-h1">Outsourcing IS/IT</h1>
                              <div className="col-sm-5 slider-image"><img alt="" src={outsourcingIMG}/></div>
                              <div className="col-sm-7 slider-description">
                                  <h2>Úplný outsourcing</h2>
                                  <h2>Personální outsourcing</h2>
                                  <h2>Hardwarový outsourcing</h2>
                                  <div className="col-sm-12 button-wrap">
                                      <Link to="/sluzby-a-produkty/outsourcing-is-it"><button className="button-slider">Více informací</button></Link>
                                  </div>
                              </div>
                          </div>
                      </Slider>


                  </div>



              </div>

    );
  }
}

export default MainHome;



// WEBPACK FOOTER //
// ./src/MainHome.js